<template>
	<div :class="['c-productdetail__orderwrapper', { 'has-nettoprice': isLoggedIn && getProductCustomerPrice() != 0 }]">
		<div class="c-productdetail__costs">
			<Price :is-logged-in="isLoggedIn" :price-promo="getProductCustomerPrice()" :price="getProductStandardPrice()" />
		</div>
		<div class="c-productdetail__amount">
			<Amount :amount="amount" @changeAmount="changeAmount($event)" />
			<AddToCartButton @placeInBasket="placeInBasket()" @loginPopup="loginPopup()" :isLoggedIn="isLoggedIn" :amount="amount" />
		</div>
		<Popup :show-popup="showAddedToCartPopup" @closePopup="showAddedToCartPopup = false">
			<template #title>
				<h3>Toegevoegd aan winkelwagen</h3>
			</template>
			<template #content>
				<div class="c-popup__cartitem">
					<div class="c-popup__cartitem__image">
						<img :src="productDetails.imageUrl" :alt="productDetails.itemDescription || 'Product titel'" />
					</div>
					<div class="c-popup__cartitem__text">
						<h5>{{productDetails.itemDescription}}</h5>
						<p>
							Artikelnummer: {{ productDetails.itemNo }}<br />
							Aantal: {{ amount }}
						</p>
					</div>
				</div>
			</template>
			<template #footer>
				<a href="/winkelwagen" class="btn btn-primary">
					<i class="fal fa-shopping-cart" />
					<span>Verder naar bestellen</span>
				</a>
				<a class="btn btn-link" @click="closeCartPopup">Verder winkelen</a>
			</template>
		</Popup>
		<Popup :show-popup="showLoginPopup" @closePopup="showLoginPopup = false">
			<template #title>
				<h3>Inloggen vereist</h3>
			</template>
			<template #content>
				<div class="c-popup__content--text">Inloggen vereist om artikelen aan de winkelwagen toe te voegen.</div>
			</template>
			<template #footer>
				<a class="btn btn-primary" @click="btnLogin()">
					<i class="fal fa-user" />
					<span>Inloggen</span>
				</a>
				<a class="btn btn-link" @click="showLoginPopup = false">Niet inloggen</a>
			</template>
		</Popup>
	</div>
</template>
<script>
import axios from 'axios';
import Amount from '../../modules/products/components/general/Product/Amount.vue';
import Price from '../../modules/products/components/general/Product/Price.vue';
import Popup from '../../modules/products/components/general/Product/Popup.vue';
import AddToCartButton from '../../modules/products/components/general/Product/AddToCartButton.vue';

export default {
	components: {
		Amount,
		Price,
		Popup,
		AddToCartButton
	},
	props: {
		productDetails: {
			type: Object,
			required: true
		},
	},
	data() {
		return {
			basketClient: null,
			amount: 1,
			isLoggedIn: this.productDetails.isLoggedIn === 'True',
			showAddedToCartPopup: false,
			showLoginPopup: false
		};
	},
	created() {
		this.basketClient = axios.create({
			baseURL: '/api/winkelwagen'
		});
		this.basketClient.defaults.headers.common['Content-Type'] = 'application/json';
		this.basketClient.defaults.timeout = 0;
		this.basketClient.defaults.method = 'post';
	},
	methods: {
		btnLogin() {
			const abplogin = document.getElementById('abp.io');
			if (abplogin) {
				abplogin.click();
			}
		},
		loginPopup() {
			this.showLoginPopup = true;
		},
		getProductStandardPrice() {
			return Number(this.productDetails.standardPrice.replace(/,/g, '.'));
		},
		getProductCustomerPrice() {
			return Number(this.productDetails.customerPrice.replace(/,/g, '.'));
		},
		placeInBasket() {
			const basketId = localStorage.getItem('basketId');
			const basketItem = {
				basketId: basketId,
				itemNo: this.productDetails.itemNo,
				itemUOM: this.productDetails.itemUOM,
				itemDescription: this.productDetails.itemDescription,
				amount: this.amount,
				standardPrice: this.productDetails.standardPrice,
				customerPrice: this.productDetails.customerPrice,
				data: `{"Verzendbaar": ${this.productDetails.isVerzendbaar.toString().toLocaleLowerCase()}, "ImageUrl": "${this.productDetails.imageUrl}"}`
			};

			this.basketClient
				.post('/item/add', basketItem)
				.then(response => {
					this.updateLocalStorageAndDispatchEvent(response.data);
					this.showAddedToCartPopup = true;
				})
				.catch(e => {
					console.error(e);
				});
		},
		closeCartPopup() {
			this.changeAmount(1);
			this.showAddedToCartPopup = false;
		},
		changeAmount(amount) {
			this.amount = amount;
		},
		updateLocalStorageAndDispatchEvent(customerBasket) {
			if (customerBasket === null || customerBasket === '' || typeof customerBasket.BasketItems === 'undefined') {
				return;
			}

			this.amountInBasket = 0;
			for (var i = 0, _len = customerBasket.BasketItems.length; i < _len; i++) {
				this.amountInBasket += customerBasket.BasketItems[i].Amount;
			}

			localStorage.setItem('amountInBasket', this.amountInBasket);
			window.dispatchEvent(
				new CustomEvent('aquaco-basket-changed', {
					detail: {
						amount: this.amountInBasket
					}
				})
			);
		}
	}
};
</script>
